export default __webpack_public_path__ + "static/media/81.9ce514c3.jpeg";